import { SphereItem } from './sphere_item';
export default class VideoItem extends SphereItem {
    constructor() {
        super(...arguments);
        this.wasPausedManually = false;
        this.ended = false;
        this.isAllowedToPlay = true;
    }
    allowToLoad(allow) {
        if (allow)
            this.object3D.preloadVideo();
        else
            this.object3D.unloadVideo();
    }
    allowToPlay(allow) {
        this.isAllowedToPlay = allow;
        if (allow && !this.object3D.isPlaying() && this.canAutoplay())
            this.object3D.setPlaying(true);
        if (!allow && this.object3D.isPlaying())
            this.object3D.setPlaying(false);
    }
    canAutoplay() {
        return this.config().autoplay && this.isAllowedToPlay && !this.wasPausedManually && !this.ended;
    }
    config() {
        return this.itemData.data;
    }
}
